import { render, staticRenderFns } from "./UpdateRoleAuthority.vue?vue&type=template&id=4c80c112"
import script from "./UpdateRoleAuthority.vue?vue&type=script&lang=js"
export * from "./UpdateRoleAuthority.vue?vue&type=script&lang=js"
import style0 from "./UpdateRoleAuthority.vue?vue&type=style&index=0&id=4c80c112&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports